import { CategoryElement, CategoryOut } from "@/domain/category.interface";
import { axios } from "@/utils/axios.create";

const findByType = async ({
  type,
  status,
}: {
  type?: string;
  status: string;
}): Promise<CategoryOut[]> => {
  return axios
    .get("/categories/" + type)
    .then((res) => {
      if (status === "ACTIVE" && res.data.body) {
        const categories = res.data.body;
        const filtered = categories?.filter(
          (category: CategoryOut) => category.status === status,
        );
        return filtered;
      }
      return res.data.body;
    })
    .catch((err) => {
      throw new Error(
        err.response?.data?.message || "Failed to fetch categories",
      );
    });
};

export const CategoryService = {
  findByType,
};
